/**
 * @function toTitleCase
 *
 * Util function to format a string to handle casing,
 * returning any passed string to 'Title Case'.
 *
 * If undefined, will return an empty string.
 *
 * @param {string | undefined} str The string to format to 'Title Case'
 * @returns {string} The 'Title Case' formatted string
 */
export const toTitleCase = (str: string | undefined): string => {
  if (!str) {
    return '';
  }
  const underscoreSplit = str.split('_');
  if (underscoreSplit.length > 0) {
    return underscoreSplit
      .map(
        (word) =>
          word.charAt(0).toLocaleUpperCase() +
          word.slice(1).toLocaleLowerCase(),
      )
      .join(' ');
  }
  return str
    .split(' ')
    .map(
      (word) =>
        word.charAt(0).toLocaleUpperCase() + word.slice(1).toLocaleLowerCase(),
    )
    .join(' ');
};
